export default __webpack_public_path__ + "static/media/inactiveCalendar.f7c026cb.svg";